/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Bodyfat_Range_CalibratedInputs */

const en_us2_body_assessment_bodyfat_range_calibrated = /** @type {(inputs: Body_Assessment_Bodyfat_Range_CalibratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The range comes from the reference population. It is wide because a photo estimate is not a measurement.`)
};

const pt_br2_body_assessment_bodyfat_range_calibrated = /** @type {(inputs: Body_Assessment_Bodyfat_Range_CalibratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A faixa vem da população de referência. Ela é larga porque uma estimativa por foto não é uma medição.`)
};

const es_419_body_assessment_bodyfat_range_calibrated = /** @type {(inputs: Body_Assessment_Bodyfat_Range_CalibratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El rango viene de la población de referencia. Es amplio porque una estimación por foto no es una medición.`)
};

const pt_pt2_body_assessment_bodyfat_range_calibrated = /** @type {(inputs: Body_Assessment_Bodyfat_Range_CalibratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O intervalo vem da população de referência. É largo porque uma estimativa por foto não é uma medição.`)
};

const fr_fr2_body_assessment_bodyfat_range_calibrated = /** @type {(inputs: Body_Assessment_Bodyfat_Range_CalibratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La fourchette vient de la population de référence. Elle est large parce qu'une estimation par photo n'est pas une mesure.`)
};

const de_de2_body_assessment_bodyfat_range_calibrated = /** @type {(inputs: Body_Assessment_Bodyfat_Range_CalibratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Spanne stammt aus der Referenzbevölkerung. Sie ist breit, weil eine Fotoschätzung keine Messung ist.`)
};

const it_it2_body_assessment_bodyfat_range_calibrated = /** @type {(inputs: Body_Assessment_Bodyfat_Range_CalibratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'intervallo viene dalla popolazione di riferimento. È ampio perché una stima da foto non è una misurazione.`)
};

/**
* | output |
* | --- |
* | "The range comes from the reference population. It is wide because a photo estimate is not a measurement." |
*
* @param {Body_Assessment_Bodyfat_Range_CalibratedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_bodyfat_range_calibrated = /** @type {((inputs?: Body_Assessment_Bodyfat_Range_CalibratedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Bodyfat_Range_CalibratedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_bodyfat_range_calibrated(inputs)
	if (locale === "es-419") return es_419_body_assessment_bodyfat_range_calibrated(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_bodyfat_range_calibrated(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_bodyfat_range_calibrated(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_bodyfat_range_calibrated(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_bodyfat_range_calibrated(inputs)
	return en_us2_body_assessment_bodyfat_range_calibrated(inputs)
});
export { body_assessment_bodyfat_range_calibrated as "body-assessment.bodyfat_range_calibrated" }